import React from "react";

export default function MSAccess_Randomize() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Randomize</h1>
      <p>This is the MSAccess_Randomize component generated from the SQL JSON.</p>
    </div>
  );
}
